import React, { useContext, useState, useEffect } from 'react'
import './HomeNavLinks.css'
import { NavLink } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'

const HomeNavLinks = (props) => {
	console.log('inside HomeNavLinks leagueId is ' + props.leagueId)

	// local leagueId that can come from props OR database
	const [leagueId, setLeagueId] = useState(props.leagueId || null)

	// ✅ NEW: track if there are multiple current leagues
	const [multipleCurrentLeagues, setMultipleCurrentLeagues] = useState(false)

	const auth = useContext(AuthContext)

	// ----------------------------
	// FETCH CURRENT TOURNAMENT
	// ----------------------------
	useEffect(() => {
		// If parent already supplied leagueId, do nothing
		if (props.leagueId) {
			setLeagueId(props.leagueId)
			setMultipleCurrentLeagues(false)
			return
		}

		const getCurrentLeague = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/current`,
				)

				if (!response.ok) throw new Error('Failed to fetch current league')

				const data = await response.json()

				// ✅ if backend says multiple current leagues, force user to choose
				if (data.multipleCurrentLeagues) {
					setMultipleCurrentLeagues(true)
					setLeagueId(null)
					return
				}

				// ✅ single current league
				setMultipleCurrentLeagues(false)
				setLeagueId(data.leagueId)
			} catch (err) {
				console.error('Could not load current league:', err)
				// safest fallback: make them choose
				setMultipleCurrentLeagues(true)
				setLeagueId(null)
			}
		}

		getCurrentLeague()
	}, [props.leagueId])

	// ----------------------------

	let page

	if (auth.isLoggedIn) {
		page = '/admin/leagues/current'
	} else {
		page = '/admin/login'
	}

	// ✅ Only "auto-route" when we truly have exactly one current league
	const canAutoRoute = leagueId && !multipleCurrentLeagues

	return (
		<ul className='home-nav-links'>
			<li>
				<NavLink to={`https://coolhockeyevents.com/`}>HOME</NavLink>
			</li>
			<li>
				<NavLink to={'/schedule'}>SCHEDULE</NavLink>
			</li>

			{canAutoRoute && (
				<li>
					<NavLink to={`/league/${leagueId}`}>STANDINGS</NavLink>
				</li>
			)}

			{canAutoRoute && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/league/scoring/${leagueId}`}>STAT LEADERS</NavLink>
				</li>
			)}

			{!canAutoRoute && (
				<li>
					<NavLink to={'/statsandstandings'}>STANDINGS</NavLink>
				</li>
			)}

			{!canAutoRoute && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/scoringleaders`}>STAT LEADERS</NavLink>
				</li>
			)}

			<li>
				<NavLink to={'/playerStats'}>PLAYER PAGES</NavLink>
			</li>
			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks

/* import React, { useContext, useState, useEffect, useRef } from 'react'
import './HomeNavLinks.css'
import { NavLink, Link } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'
//import NavLinksHomeDropdown from '../../../admin/components/NavLinksHomeDropdown'

const HomeNavLinks = (props) => {
	//const [isHomeMenuDropDownOpen, setHomeMenuDropDownOpen] = useState(false)

	console.log('inside HomeNavLinks leagueId is ' + props.leagueId)

	// NEW: local leagueId that can come from props OR database
	const [leagueId, setLeagueId] = useState(props.leagueId || null)

	const auth = useContext(AuthContext)
	const propsString = props.leagueId

	// ----------------------------
	// FETCH CURRENT TOURNAMENT
	// ----------------------------
	useEffect(() => {
		// If parent already supplied leagueId, do nothing
		if (props.leagueId) {
			setLeagueId(props.leagueId)
			return
		}

		const getCurrentLeague = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/current`,
				) // <-- your backend route
				if (!response.ok) throw new Error('Failed to fetch current league')

				const data = await response.json()

				// expect: { leagueId: "684374b40c277c1376096064" }
				setLeagueId(data.leagueId)
			} catch (err) {
				console.error('Could not load current league:', err)
			}
		}

		getCurrentLeague()
	}, [props.leagueId])

	// ----------------------------

	let page

	if (auth.isLoggedIn) {
		//console.log('User is logged in!')
		page = '/admin/leagues/current'
	} else {
		//console.log('User is NOT logged in!')
		page = '/admin/login'
	}
	//

	return (
		<ul className='home-nav-links'>
			<li>
				<NavLink to={`https://coolhockeyevents.com/`}>HOME</NavLink>
			</li>
			<li>
				<NavLink to={'/schedule'}>SCHEDULE</NavLink>
			</li>
			{leagueId && (
				<li>
					<NavLink to={`/league/${leagueId}`}>STANDINGS</NavLink>
				</li>
			)}

			{leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/league/scoring/${leagueId}`}>SCORING LEADERS</NavLink>
				</li>
			)}

			{!leagueId && (
				<li>
					<NavLink to={'/statsandstandings'}>STANDINGS</NavLink>
				</li>
			)}

			{!leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/scoringleaders`}>SCORING LEADERS</NavLink>
				</li>
			)}
			<li>
				<NavLink to={'/playerStats'}>PLAYER PAGES</NavLink>
			</li>
			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks
 */
